module.exports = __webpack_public_path__ + "videos/whats-new_en.3f39e21.mp4";